import React from 'react';

import PropTypes from 'prop-types';

import { MarkedListItemContainer } from './styles';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';

export const MarkedListItem = (props) => {
    return (
        <MarkedListItemContainer>
            <Icon name="check" color="purple" rightIndent="24px" />
            <Text>{props.text}</Text>
        </MarkedListItemContainer>
    );
};

MarkedListItem.propTypes = {
    text: PropTypes.string,
};
